export class EntryCondition<E extends string> {
    public name: string;
    public check: () => boolean;
    public gameState: E | undefined;
    public gameSubState: E | undefined;

    constructor(name: string, check: () => boolean, gameState?: E, gameSubState?: E) {
        this.name = name;
        this.check = check;
        this.gameState = gameState;
        this.gameSubState = gameSubState;
    }
}
